<template>
	<el-card class="import-card" shadow="never" :body-style="{ padding: 0 }">

		<!-- Header -->
		<div class="import-header" v-if="!completeImporting">
			<el-row type="flex" justify="space-between" align="middle">
				<el-col :span="6">
					<div class="grid-content" v-if="rows">
						<span class="heading">{{ getHeading }}</span>
					</div>
				</el-col>
				<template v-if="patient">
					<el-col :span="9" style="display: flex; justify-content: center;">

					</el-col>
					<el-col :span="9" style="display: flex; justify-content: flex-end;">
						<div class="next grid-content" v-if="rows">
							<LoadingButton
								type="primary"
								:disabled="columnError !== ''"
								:loading="completingImport"
								@click="completeImport">
								<b>Complete Import</b>
							</LoadingButton>
						</div>
					</el-col>
				</template>
			</el-row>
		</div>

		<div class="body" v-if="importing">
			<Loading :text="importing ? 'Importing spreadsheet...' : 'Processing rows...'" background="#f0f0f0"></Loading>
		</div>

		<!-- Show the three steps for importing in sequence -->
		<div class="body" v-else-if="rows">

			<ConfirmColumnTable v-if="fileUploadSuccess"
				v-bind:patient="fileUploadSuccess.row"
				:column-back="fileUploadSuccess.column"
				:column-error="columnError"
				@change="columnChange"
				@totalEventCount="getTotalEvents">
			</ConfirmColumnTable>


			<div class="column-error" v-if="columnError !== '' && rows.length > 0">
				<DangerIcon></DangerIcon>
				Please choose a column for <span v-html="columnError"></span> before proceeding to the next step.
			</div>
		</div>

		<!-- Initial dialog to show a button to upload a new file -->
		<ImportUpload v-else 
			:confirmed-column="confirmedColumn"
			@rows="parseRows"></ImportUpload>
	</el-card>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/module/component/Loading'
import LoadingButton from '@/module/component/LoadingButton'
import isEmptyObj from '@/module/util/empty-object'
import joinLastSeparator from '@/module/util/join-last-separator'

// import ImportTable from './Table'
import ImportStatistics from './Statistics'
import ImportUpload from './Upload'
import DangerIcon from '../icons/Danger'

import ImportTables from './table/components'

import { parseEvents } from '../util/parse-file'
import parseFile from '../util/parse-file'

const XLSX_SCRIPTS = [
	'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.8.0/jszip.js',
	'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.8.0/xlsx.js'
]

export default {
	name: 'patient-import-card',

	data() {
		return {
			rows: null,
			step: null,
			importing: false,
			customColumn: null,
			loadingButton: false,
			loadedButton: false,
			completeImporting: false,
			completingImport: false,
			patient: null,
			column: null,
			totalEvents: null,
			confirmedColumn: false
		}
	},

	mounted() {
		this.loadPatients()
	},

	watch: {
		loadedAllProviders: {
			immediate: true,
			handler(value) {
				if(value)
					this.loadAllProviderPatients()
			}
		}
	},

	methods: {
		...mapActions('provider', [
			'batchCreatePatient',
			'loadPatients',
			'loadAllProviderPatients',
			'confirmImportColumn'
		]),
		...mapActions('content', [
			'loadContent'
		]),
		columnChange(column) {
			this.confirmedColumn = column
		},
		startImport() {
			this.importing = true
		},
		parseRows(rows) {
			this.rows = rows
			this.patient = rows
			this.step = 0
			this.importing = false
			// parseFile(rows, this.getProviderList, this.events).then((result) => {
				
			// 	this.patient = result.patient
			// 	this.column = this.getSingularColumns(result.column)
			// 	
			// })
			// If the user needs to confirm the columns, confirm and then parse results again
			// while (result.confirm) {
			// 	result = parseFile(rows, this.getProvider, this.existingPatients, this.events, this.column)
			//
			// 	if (result.cancel)
			// 		return
			//
			// 	this.patient = result.patient
			// 	this.column = result.column
			// }


		},
		nextStep() {			
			if (this.step == 0 && this.customColumn) {
				this.loadingButton = true
				parseFile(this.rows, this.getProviderList, this.events, this.customColumn).then((result) => {
					this.patient = result.patient
					this.column = this.customColumn
					this.loadingButton = false
					this.step++
				}).catch((error) => {
					console.error('Error in parsing file ', error)
					this.step++
				})
				
			}
			else if(this.step == 1) {
				const column = this.customColumn ? this.customColumn : this.column
				this.patient = parseEvents(this.patient, this.events, column.event)
				this.step++
				document.getElementById('import').scrollTop = 0
			}
			else if(this.step == 2) {
				// Validating rows with selected events
				this.patient = this.patient.map((patient) => {
					if(patient.data.event && Array.isArray(patient.data.event)) {
						if(patient.data.event.every((event) => event.id)) {
							patient.invalid = false
							patient.confirmed = null
						}
					}
					return patient
				})
				this.step++
				document.getElementById('import').scrollTop = 0
			}
			else {
				this.step++
				document.getElementById('import').scrollTop = 0
			}
		},
		previousStep() {
			this.step--
			document.getElementById('import').scrollTop = 0
		},
		importingPatients() {
			this.completeImporting = true
		},
		/**
		 * Goes through the column object and removes 
		 * columns with plural matches except `event`
		 * @param {*} column
		 */
		getSingularColumns(column) {
			try {
				Object.keys(column).forEach((key) => {
					if(Object.keys(column[key]).length > 1 && key !== 'event')
						column[key] = {}
				})
			} catch (error) {
				console.error('Problem removing duplicates from column ', error)
			}
			return column
		},
		completeImport() {
			this.completingImport = true
			// if (!this.confirmedColumn.hasOwnProperty('email')) this.confirmedColumn.email = ''
			this.confirmImportColumn(this.confirmedColumn)
				.then((result) => {
					if(result.success) {
						this.rows = false
						this.confirmedColumn = true
					}
						
				})
		},
		getTotalEvents(count) {
			this.totalEvents = count
		},
	},

	computed: {
		...mapState('provider', [
			'creatingPatient',
			'loadedAllProviders',
			'fileUploadSuccess'
		]),
		...mapGetters('provider', [
			'getProvider',
			'getProviderName',
			'getProviderList',
			'getPatientList',
			'getAllProviderPatientList'
		]),
		...mapGetters('content', [
			'getContent'
		]),
		percentage() {
			let totalSteps = 4
			return (this.step + 1) * 100 / totalSteps
		},
		getHeading() {
			let heading
			switch(this.step) {
				case 0:
					heading = 'Confirm Columns'
					break
				case 1:
					heading = 'Enroll Patients'
					break
				case 2:
					heading = 'Schedule Events'
					break
				case 3:
					heading = 'Review Summary'
					break
			}
			return heading
		},
		existingPatients() {
			return this.getAllProviderPatientList
		},
		provider() {
			return this.getProvider
		},
		profiles() {
			if (this.provider)
				return this.provider.profile
			return []
		},
		events() {
			try {
				return this.getProviderList.map((provider) => {
					const providerEvents = provider.profile.flatMap((profile) => {
							return profile.event.map((id) => ({
								...this.getContent('event', id),
								profileId: profile.id
							}))
						}
					)
					return {
						providerId: provider.provider,
						providerName: provider.name,
						events: providerEvents 
					}
				})
			} catch (error) {
				console.error(error)
				return []	
			}
		},
		/**
		 * Calculates the string error(in html)
		 * for column selection. Returns empty string
		 * if no error
		 */
		columnError() {
			/**
			 * Array of mandatory coulmns required with labels
			 */
			const MandatoryArr = [
				{
					key: 'name',
					label: '<b>Name</b>'
				},
				// {
				// 	key: 'email',
				// 	label: '<b>Email</b>'
				// },
				{
					key: 'date',
					label: '<b>Date</b>'
				},
			]

			/**
			 * Filtering array with keys that have empty objects
			 * in `this.confirmedColumn` and mapping to label
			 * @type {[String]}
			 */
			const labelErrorArr = MandatoryArr
				.filter(({ key }) => !this.confirmedColumn.hasOwnProperty(key))
				.map(({ label }) => label)
			return joinLastSeparator(labelErrorArr, ' , ', ' and ') 
		}
	},

	components: {
		Loading,
		ImportUpload,
		LoadingButton,
		DangerIcon,

		...ImportTables
	}
}
</script>

<style lang="scss" scoped>
@import "../../patient/card/style.scss";
@import "@/module/app/theme/color.scss";

.import-card {
	border: 0;
}

.action {
	padding: 100px 0;
	background: lighten(#2D3E4F, 60%);
	text-align: center;
}

.next {
	display: inline-block;
	.el-button {
		width: 148px;
		height: 36px;
		font-size: 14px; 
		border-radius: 0px;
		line-height: 0;
	}
	.el-button--primary.is-plain {
		color: #666666;
		border-color: #999;
		background-color: #f8f8f8;
	}
	.el-button--primary.is-plain:hover {
		color: #666;
		background-color: #eeeeee;
		border-color: #999;
	}
	.el-button--primary.loading-button {
		color: #fff;
		background-color: #2d3e4f;
	}
	.el-button--primary.loading-button:hover {
		color: #fff;
		background-color: #202D39;
	}
}


.body {
    background: #eeeeee;
}

.oval {
	height: 3px;
	width: 3px;
	margin-bottom: 2px;
	background-color: #666666;
	border-radius: 50%;
	display: inline-block;
	margin-left: 15px;
	margin-right: 15px;
}
.import-header {
	padding: 15px 16px 4px;
	background: #ffffff;
}
.heading {
	font-size: 20px;
	font-weight: bold;
	color: #333333; 
}
.stepCount {
	font-size: 14px;
	color: #666666;
}
.status {
	border-radius: 15px;
	border: solid 1px #c0d6eb;
	background-color: #e4f0fd;
	font-size: 16px;
	color: #333333;
	padding: 4px 25px;
}
</style>

<style scoped>
.import-progress-success >>> .el-progress-bar__inner {
	background-color: #44b358;
}
</style>
